import axios, { AxiosPromise } from 'axios';

export const GET_NOTIFICATIONS = '/notifications/getNotifications';
export const GET_NOTIFICATIONS_EXCEL = '/notifications/getNotificationsForExcelFile';

export interface QueryParams {
  pageNumber?: number;
  pageSize?: number;
  [key: string]: any;
}

export interface CancellationHandlers {
  cancelToken?: any;
  signal?: AbortSignal;
  [key: string]: any;
}

export function getNotifications(
  queryParams: QueryParams,
  cancellationHandlers?: CancellationHandlers
): AxiosPromise<any> {
  return axios.get(GET_NOTIFICATIONS, {
    params: queryParams,
    ...cancellationHandlers
  });
}

export function getNotificationsForExcelFile(
  queryParams: QueryParams
): AxiosPromise<any> {
  return axios.get(GET_NOTIFICATIONS_EXCEL, {
    params: queryParams
  });
}